import Link from "next/link";
import React, { ReactElement, useState } from "react";
import styles from "./headerBanner.module.scss";
import { XClose } from "@untitled-ui/icons-react";

export const HeaderBanner = (props: Props): ReactElement => {
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return <></>;
  }

  const Wrapper = props.url ? Link : "div";

  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <Wrapper
          className={styles.link}
          href={props.url}
          onClick={props.onClick}
        >
          <span
            className={styles.label}
            dangerouslySetInnerHTML={{
              __html: props.label,
            }}
          ></span>
          {props.buttonLabel && (
            <button className={styles.ctaButton}>{props.buttonLabel}</button>
          )}
        </Wrapper>

        {props.hideCloseButton !== true && (
          <button
            className={styles.closeButton}
            onClick={() => setVisible(false)}
          >
            <XClose />
          </button>
        )}
      </div>
    </section>
  );
};

interface Props {
  url?: string;
  label: string;
  buttonLabel?: string;
  onClick?: () => void;
  hideCloseButton?: boolean;
}
